/**
 * Root Vuex Store Configuration
 *
 * Centralized state management for the Carenuity Customer Frontend
 * Registers all store modules with type safety and plugins
 */

console.log('[Store] 🏪 Creating Vuex store...');

import { createStore, Store } from 'vuex';
import type { RootState } from './types';

// Module imports
import authModule from './modules/auth/index'; // TypeScript module
import deviceModule from './modules/device/index';
import alarmsModule from './modules/alarms/index';
import selectionModule from './modules/selection/index'; // TypeScript module
import catalogModule from './modules/catalog/index'; // TypeScript module
import notificationsModule from './modules/notifications/index'; // TypeScript module

console.log('[Store] 📦 All modules imported');
console.log('[Store] 🔔 Notifications module:', notificationsModule);

// Plugin imports
import createPersistencePlugin from './plugins/persistencePlugin';
import createStoreResetPlugin from './plugins/storeReset';

/**
 * Create and configure the Vuex store
 */
const store: Store<RootState> = createStore<RootState>({
  state: {} as RootState,
  mutations: {},
  actions: {},
  modules: {
    auth: authModule,
    device: deviceModule,
    alarms: alarmsModule,
    selection: selectionModule,
    catalog: catalogModule,    // Primary data store (normalized)
    notifications: notificationsModule,
  },
  plugins: [createPersistencePlugin(), createStoreResetPlugin()],
});

console.log('[Store] ✅ Store created successfully');
console.log('[Store] Modules registered:', Object.keys(store.state));

export default store;
